import wx from 'weixin-js-sdk'
import publicObj from "./public"
import store from '../../store/index'
import orderApi from '../../axios/order'

// setTimeout(()=>{
//     let shareBody = {
//       title : '喂！来领新人礼',
//       desc : '全周期呵护你的心爱之物。包包、鞋子、衣服等都能用！',
//       link: window.location.href,
//       // imgUrl:'https://img.chenzhen.shop/2022/10/22/e12b0585-a353-4b34-9e9a-a9aac59a10c4.jpg'
//     }; 
//     wxShare(shareBody);
//   },100)
// 
// imgUrl  =>  http://mi.baozheng.cc/XXX.png  放在本地文件夹下
// 只能通过公众号分享

let token = store.state.token;
let path = location.href;
export default function wxShare (data={title:"包拯—我和明星都在追的包包护理品牌",link:window.location.href,imgUrl:"",desc:"打理心爱之物"},callback) {
  const img = checkImgUrl(data.imgUrl) ? data.imgUrl : "https://baozheng-nice-new.baozheng.cc/uploads/content/file/data/000/000/097/4452b221.jpg"
  const types = [
      "onMenuShareTimeline",//分享朋友圈
      "onMenuShareAppMessage",//分享给朋友
  ]
  return new Promise((resolve,reject) => {
      if ( publicObj.isWeiXin() ) { 
          wx.ready(() => {
                let params_share = {
                    token : token,
                    weChatState : '设置配置成功',
                    path : path
                }
                // orderApi.shareLog(params_share).then((r)=>{
                    
                // })
              types.forEach(shareName => {
                  wx[shareName]({
                        title : data.title,
                        link : data.link,
                        desc : data.desc,
                        imgUrl :img,
                    //   ...{imgUrl: img},
                      success:function ( res ) {
                            callback?callback():'';
                            setTimeout(() => {
                                // alert(JSON.stringify(res))
                                resolve(res)
                            },500)
                      }, 
                      cancel:function ( err ) {
                          reject(err)
                      },
                      fail: function (res) {
                      
                      }
                  })
              })
          } )
      } else {
          reject("非微信浏览器")
      }
  })
}

const checkImgUrl = url=>{
  let isUse
  if(!url) return isUse = false
  const image = new Image()
  image.src = url
  image.onerror = function ( err ) {
      isUse = false
  }
  isUse = true
  return isUse
}
